/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */
export var defaultLogoParams = {
  iconColor: 'inherit',
  label: '',
  size: 'medium',
  textColor: 'currentColor'
};
export var legacyDefaultLogoParams = {
  iconGradientStart: 'inherit',
  iconGradientStop: 'inherit'
};

/**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */